import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "control-font"
}
const _hoisted_2 = { class: "control-font__unit" }
const _hoisted_3 = { class: "control-font__check" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "control-font__unit" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "control-font__option option",
  style: {"display":"block"}
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "reading-settings control-font__family-link" }
const _hoisted_10 = { class: "control-font__unit" }
const _hoisted_11 = { class: "control-font__check" }
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = { class: "control-font__unit" }
const _hoisted_14 = { class: "control-font__check" }
const _hoisted_15 = ["title", "onClick"]
const _hoisted_16 = { class: "control-font__btn-box control__font__unit" }

import { onBeforeMount, ref } from 'vue'

import type { DocView } from '@/models/doc'
import {
  FONT_FAMILY_OPTIONS,
  FontSize,
  LineHeight,
  MarginSize,
} from '@/models/doc.settings'
import type { FontFamilyOption } from '@/models/doc.settings'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarSettings',
  props: {
    doc: {}
  },
  setup(__props: any) {

/* eslint-disable vue/no-mutating-props */
const props = __props
const showFonts = ref(false)
const selectedFontFamily = ref<FontFamilyOption>(FONT_FAMILY_OPTIONS[0])

onBeforeMount(() => {
  selectedFontFamily.value = props.doc.settings.selectedFontFamily
})

function hideSettings(): void {
  props.doc.controls.hideReadingSettings()
}

function setFontSize(fontSize: FontSize): void {
  props.doc.settings.fontSize = fontSize
  props.doc.settings.saveSettings()
}

function setMargins(marginSize: MarginSize): void {
  props.doc.settings.marginSize = marginSize
  props.doc.settings.saveSettings()
}

function setLineHeight(lineHeight: LineHeight): void {
  props.doc.settings.lineHeight = lineHeight
  props.doc.settings.saveSettings()
}

function setFontFamily(fontFamily: FontFamilyOption): void {
  props.doc.settings.fontFamily = fontFamily.font
  selectedFontFamily.value = fontFamily
  props.doc.settings.saveSettings()
}

function resetToDefaults(): void {
  props.doc.settings.resetToDefaults()
  selectedFontFamily.value = props.doc.settings.selectedFontFamily
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (__props.doc)
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(__props.doc.controls.readingSettingsClass),
        title: "Reading settings",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.doc.controls.toggleReadingSettings($event)))
      }, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "control__icon-box" }, [
          _createElementVNode("span", { class: "control__icon iconfont icontrol-font" })
        ], -1)),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (__props.doc.controls.readingSettingsVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "control-font__title" }, "Font Size", -1)),
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doc.settings.readingOptions.fontOptions, (item, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: item.title,
                          class: _normalizeClass(__props.doc.settings.getFontSizeClass(item, index)),
                          title: item.title,
                          onClick: ($event: any) => (setFontSize(item.size))
                        }, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("div", { class: "control-font__size-icon-box" }, [
                            _createElementVNode("span", { class: "control-font__size-icon icontrol-font" })
                          ], -1)
                        ]))], 10, _hoisted_4))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "control-font__title" }, "Font Family", -1)),
                    _createElementVNode("div", {
                      class: "control-font__select select-box",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showFonts.value = !showFonts.value))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass([{ 'control-font__menu-icon-active': showFonts.value }, "control-font__menu-icon iconfont isub-menu"])
                      }, null, 2),
                      _createElementVNode("input", {
                        class: "control-font__family-name select",
                        type: "text",
                        onfocus: "this.blur()",
                        style: _normalizeStyle({ 'font-family': selectedFontFamily.value.font }),
                        placeholder: selectedFontFamily.value.title
                      }, null, 12, _hoisted_6),
                      (showFonts.value)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doc.settings.readingOptions.fontFamilyOptions, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.title,
                                class: "control-font__option-c",
                                onClick: ($event: any) => (setFontFamily(item))
                              }, [
                                _createElementVNode("button", _hoisted_9, [
                                  _createElementVNode("span", {
                                    class: "select-c",
                                    style: _normalizeStyle({ 'font-family': item.font })
                                  }, _toDisplayString(item.title), 5)
                                ])
                              ], 8, _hoisted_8))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "control-font__title" }, "Line Height", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doc.settings.readingOptions.lineOptions, (item, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: item.title,
                          class: _normalizeClass(__props.doc.settings.getLineHeightClass(item, index)),
                          "data-setting": "item.size",
                          title: item.title,
                          onClick: ($event: any) => (setLineHeight(item.size))
                        }, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("span", { class: "control-font__line-height-icon" }, null, -1),
                          _createElementVNode("span", { class: "control-font__line-height-icon" }, null, -1),
                          _createElementVNode("span", { class: "control-font__line-height-icon" }, null, -1)
                        ]))], 10, _hoisted_12))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "control-font__title" }, "Margins", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doc.settings.readingOptions.marginOptions, (item, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: item.title,
                          class: _normalizeClass(__props.doc.settings.getMarginClass(item, index)),
                          "data-setting": "item.size",
                          title: item.title,
                          onClick: ($event: any) => (setMargins(item.size))
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("span", { class: "control-font__margins-icon" }, null, -1),
                          _createElementVNode("span", { class: "control-font__margins-icon" }, null, -1),
                          _createElementVNode("span", { class: "control-font__margins-icon" }, null, -1)
                        ]))], 10, _hoisted_15))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      class: "control-font__btn btns btns--white btns--full btns--small reading-settings",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (resetToDefaults()))
                    }, "Reset to Defaults")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_click_outside, hideSettings]
      ])
    : _createCommentVNode("", true)
}
}

})